<section class="wrapper">
    <!-- <div class="error-info" *ngIf="errMsg"> {{ errMsg.error }}</div> -->

    <div fxLayoutAlign="center center">
        <mat-spinner [diameter]="50" [strokeWidth]="3"></mat-spinner>
    </div>    
</section>
